import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function GiftLine({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M12.25 2.5C12.7767 2.49994 13.2942 2.63855 13.7503 2.9019C14.2065 3.16525 14.5852 3.54406 14.8486 4.00022C15.1119 4.45639 15.2505 4.97385 15.2504 5.50056C15.2503 6.02728 15.1115 6.54468 14.848 7.00075L18.25 7V8.5H16.75V16C16.75 16.1989 16.671 16.3897 16.5303 16.5303C16.3897 16.671 16.1989 16.75 16 16.75H4C3.80109 16.75 3.61032 16.671 3.46967 16.5303C3.32902 16.3897 3.25 16.1989 3.25 16V8.5H1.75V7L5.152 7.00075C4.7799 6.35642 4.66052 5.5968 4.81704 4.86938C4.97356 4.14197 5.39481 3.49868 5.999 3.06442C6.60319 2.63016 7.3472 2.43592 8.08656 2.51941C8.82592 2.60291 9.50787 2.95819 10 3.51625C10.2809 3.19629 10.627 2.94008 11.0151 2.76481C11.4032 2.58954 11.8242 2.49925 12.25 2.5ZM9.25 8.5H4.75V15.25H9.25V8.5ZM15.25 8.5H10.75V15.25H15.25V8.5ZM7.75 4C7.36076 3.99826 6.98609 4.14789 6.70514 4.41729C6.42418 4.68668 6.25895 5.05474 6.24434 5.44371C6.22974 5.83268 6.36691 6.21209 6.62687 6.50179C6.88683 6.7915 7.24923 6.9688 7.6375 6.99625L7.75 7H9.25V5.5C9.25002 5.14155 9.12167 4.79494 8.88819 4.52295C8.65472 4.25095 8.33157 4.07156 7.97725 4.01725L7.86175 4.00375L7.75 4ZM12.25 4C11.8716 3.99988 11.5071 4.14281 11.2296 4.40013C10.9521 4.65744 10.7821 5.01014 10.7537 5.3875L10.75 5.5V7H12.25C12.6284 7.00012 12.9929 6.8572 13.2704 6.59988C13.5479 6.34256 13.7179 5.98987 13.7463 5.6125L13.75 5.5C13.75 5.10218 13.592 4.72065 13.3107 4.43934C13.0294 4.15804 12.6478 4 12.25 4Z"
        fill="currentColor"
      />
    </svg>
  )
}
